import { ConfigContext } from '@/contextAPI/configContext';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

type CalcTitle = (params?: { id?: string }) => string;

const usePageTitle = (calcTitle?: CalcTitle) => {
  const params = useParams();
  const clientName = useContext(ConfigContext)?.clientName;

  if (calcTitle) {
    let title = calcTitle(params);

    if (clientName) {
      title = `${clientName} | ${title}`;
    } else {
      title = `Polaris | ${title}`;
    }

    document.title = title;
  } else {
    document.title = 'Polaris';
  }
};

export default usePageTitle;
